'use client';

import { css } from '@bts-web/utils-style-engine';
import { HyperLinkButtonBase } from '@bts-web/core-features/common';
// import { useTradeContext } from '@bts-web/core-features/trade';
import { useEffect } from 'react';
import { FilledArrowRight } from '../../common/svgIcons';
import { useTradeContext } from '../../trade/TradeContext/TradeContext.use-client';

export const ManageSavingsPlansButton = ({
  assetId,
  translations,
  className,
}: {
  assetId?: string;
  translations: { savingsPlanManageButton: string };
  className: string;
}) => {
  const { setIsUserHavingSavingsPlans } = useTradeContext();

  useEffect(() => {
    setIsUserHavingSavingsPlans(true); // ? this component is rendered only if the user has savings plans
  }, []);

  return (
    <HyperLinkButtonBase
      className={className}
      prefetch={false}
      noPadding
      visual="ghost"
      to={assetId ? `/savings-plans?assetId=${assetId}` : '/savings-plans'}
    >
      <span>{translations.savingsPlanManageButton}</span>

      <FilledArrowRight
        className={css({
          color: 'positive.fill_primary',
        })}
        size={16}
        data-dir="rtl"
      />
    </HyperLinkButtonBase>
  );
};
